import { Component } from '@angular/core';
import { environment } from '@manager-env/environment';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    imports: [TranslocoPipe]
})
export class FooterComponent {
  currentYear = (new Date()).getFullYear();
  appVersion = environment.version;

  constructor() { }
}
